import { extendComponentMap } from "@digitale-kumpel/client-common";
import { setSiteConfig } from "@digitale-kumpel/client-common/src/siteConfig";
import { localConfig } from "./local";
import { productionConfig } from "./production";
import * as i18nConfig from "./i18n";
import { componentMap } from "./componentMap";

const environmentConfigs: any = {
  local: localConfig,
  production: productionConfig,
};

const environment = environmentConfigs[process.env.NEXT_PUBLIC_ENV || "local"];

export const projectConfig = {
  ...environment,
  i18n: {
    ...i18nConfig,
  },
};

extendComponentMap(componentMap);
setSiteConfig(projectConfig);
